export default __webpack_public_path__ + "static/media/logo_w.aac5855c.svg";